import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlaybackSpeed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 19,
	viewBox: "0 0 23 19",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M20.0339 11.1299C20.0339 13.5886 19.0373 15.8146 17.426 17.426L19 19C21.0141 16.9858 22.2598 14.2033 22.2598 11.1299C22.2598 4.98303 17.2768 0 11.1299 0C4.98303 0 0 4.98303 0 11.1299C0 14.2033 1.24576 16.9858 3.25988 19L4.83389 17.426C3.22259 15.8146 2.22598 13.5886 2.22598 11.1299C2.22598 6.21241 6.21241 2.22598 11.1299 2.22598C16.0475 2.22598 20.0339 6.21241 20.0339 11.1299ZM14.795 5.89103L9.78654 10.8995L11.3605 12.4735L16.369 7.46504L14.795 5.89103Z"
	})
});
export default SvgPlaybackSpeed;
